import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function RequireAuth({ children, isAuthenticated }) {
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to the login page if the user is not authenticated
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // If the user is authenticated, render the children components (the protected page)
  return children;
}

export default RequireAuth;
